import React from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';

const GroupTechCardWidget = (props: any) => {
  return (
    <div className="grouptech-techCard-widgte-background">
      <div className="container">
        <Row lg={3} sm={1} xs={1}>
          {props.data &&
            props.data.map((item: any, i: number) => {
              return (
                <Col key={i}>
                  <div className="grouptech-flex-container">
                    <div className="image-container">
                      <img
                        className="grouptech-img"
                        src={API.baseUrl + item.icon.url}
                        alt={item.icon.alternativeText}
                      />
                    </div>
                    <h4>{item.label}</h4>
                    <h6 dangerouslySetInnerHTML={{ __html: item.description }} />
                  </div>
                </Col>
              );
            })}
        </Row>
      </div>
    </div>
  );
};

export default GroupTechCardWidget;
